import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothGifCell ($input: UpdatePhotoboothGifCellInput!) {
        updatePhotoboothGifCell (input: $input) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            button_download_text
            button_retake_text
            button_take_text
            send_text
            sent_text
            look_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            email
            qr_code
            print
            cameralabel
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
            }
        }
    }`,

get: gql`
    query PhotoboothGifCell($id: ID!) {
        photoboothGifCell(id: $id) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            button_download_text
            description_text
            conditions1_text
            conditions2_text
            send_by_email_text
            print_text
            printed_text
            email
            qr_code
            print
            cameralabel
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
                send_by_email_text
                print_text
                printed_text
            }
        }
    }`
}
